import type { Tenant } from '#/graphql/types';
import { RequiredRule } from 'devextreme-react/validator';
import FieldDefs from '#/types/FieldDefs';
import { dataSources } from '#/modules/admin/tenants/utils/mappings';

const fields = {
  id: {
    dataField: 'id',
    label: 'ID',
    editorOptions: { readOnly: true },
  },
  name: {
    dataField: 'name',
    label: 'Name',
    isRequired: true,
    children: [<RequiredRule key="name-required" message="Name is required" />],
  },
  address: {
    dataField: 'address',
    label: 'Address',
    editorType: 'TextArea',
  },
  contacts: {
    dataField: 'contacts',
    label: 'Contacts',
    editorType: 'TextArea',
  },
  isActive: {
    dataField: 'isActive',
    label: 'Active',
    editorType: 'CheckBox',
  },
  cognitoGroupName: {
    dataField: 'cognitoGroupName',
    label: 'Cognito Group Name',
  },
  tisId: {
    dataField: 'tisId',
    label: 'TC ID',
    editorOptions: { readOnly: true },
  },
  plan: {
    dataField: 'plan',
    label: 'Plan',
    editorType: 'SelectBox',
    editorOptions: {
      items: [
        { key: 'starter', label: 'Starter' },
        { key: 'basic', label: 'Basic' },
        { key: 'professional', label: 'Professional' },
        { key: 'enterprise', label: 'Enterprise' },
        { key: 'max', label: 'Max' },
      ],
      displayExpr: 'label',
      valueExpr: 'key',
    },
  },
  dataSource: {
    dataField: 'dataSource',
    label: 'Data Source',
    editorType: 'SelectBox',
    isRequired: true,
    children: [<RequiredRule key="dataSource-required" message="Data Source is required" />],
    editorOptions: {
      items: [
        { key: dataSources.tis.key, label: dataSources.tis.label },
        { key: dataSources.fsm.key, label: dataSources.fsm.label },
      ],
      displayExpr: 'label',
      valueExpr: 'key',
    },
  },
  dataSourceId: {
    dataField: 'dataSourceId',
    label: 'Data Source ID',
    isRequired: true,
    children: [<RequiredRule key="dataSource-required" message="Data Source ID is required" />],
  },
} satisfies FieldDefs<Tenant>;

export default fields;
